<div *ngIf="project$ | async as project">

  <mat-toolbar class="mat-elevation-z6">
    <button (click)="back()" mat-icon-button>
      <mat-icon aria-label="Back">close</mat-icon>
    </button>
    <span>{{project.name}}</span>
    <span fxFlex></span>
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
  </mat-toolbar>

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="edit(project)">
      <mat-icon>edit</mat-icon>
      <span i18n>EDIT</span>
    </button>
    <button mat-menu-item (click)="remove(project)">
      <mat-icon>delete</mat-icon>
      <span i18n>REMOVE</span>
    </button>
  </mat-menu>

  <app-project-upload-status></app-project-upload-status>

  <ng-container *ngIf="(uploadStatus$ | async) === ProjectUploadStatus.Processed">

    <mat-accordion class="app-project-menu">
      <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
        <mat-expansion-panel-header>
          <mat-panel-title class="menu-title">
            <mat-icon *ngIf="project.validated">check_circle</mat-icon>
            <mat-icon *ngIf="!project.validated">fiber_manual_record</mat-icon>
            <span i18n>DESIGN</span>
          </mat-panel-title>
          <app-help *ngIf="step === 0" topic='VERTEX_BUILDINGS_EDGES'></app-help>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <app-project></app-project>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="project.validated" [expanded]="step === 1" (opened)="setStep(1)">
        <mat-expansion-panel-header>
          <mat-panel-title class="menu-title">
            <mat-icon *ngIf="stepChecked >= 1">check_circle</mat-icon>
            <mat-icon *ngIf="stepChecked < 1">fiber_manual_record</mat-icon>
            <span i18n>NETWORKS</span>
          </mat-panel-title>
          <app-help *ngIf="step === 1" topic='CREATE_NETWORKS'></app-help>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <app-simulation-list></app-simulation-list>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
        <mat-expansion-panel-header>
          <mat-panel-title class="menu-title">
            <mat-icon>layers</mat-icon>
            <span i18n>LAYERS</span>
          </mat-panel-title>
          <app-help *ngIf="step === 2" topic='SHOW_LAYERS'></app-help>
        </mat-expansion-panel-header>

        <app-layer-list [bounds]="project.location_bounds"></app-layer-list>

      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
        <mat-expansion-panel-header>
          <mat-panel-title class="menu-title">
            <mat-icon>map</mat-icon>
            <span i18n>LEGEND</span>
          </mat-panel-title>
          <app-help *ngIf="step === 3" topic='LEGEND'></app-help>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <app-result-legend *ngIf="resultMode else legendBlock"></app-result-legend>
          <ng-template #legendBlock>
            <app-layer-legend></app-layer-legend>
          </ng-template>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <app-project-square></app-project-square>
<!--    <app-project-demographic-areas></app-project-demographic-areas>-->

  </ng-container>

</div>
